import React from 'react';
import { Button } from 'react-bootstrap';
import { css } from 'twin.macro';

const PageBreak = (props) => (
    <div
        css={css`
            width: 100%;
            padding: 10px;
        `}
    >
        <h1>{props.data.fieldName}</h1>
        <Button variant="secondary">Previous</Button>
        <Button className="ml-2" variant="secondary">
            Next
        </Button>
    </div>
);

export default PageBreak;
